import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction: React.FC = () => {
    return (
        <div className="container bg-gradient-to-br from-slate-800/80 to-slate-900/90 border border-purple-600/30 rounded-3xl p-8 sm:p-12 md:p-16 text-center relative overflow-hidden mb-28">
            <div
                className="absolute inset-0 pointer-events-none"
                style={{ background: 'radial-gradient(circle at center, rgba(147, 51, 234, 0.1), rgba(37, 99, 235, 0.1), transparent)' }}
            />

            <div className="relative z-10">
                <h3 className="text-3xl md:text-4xl font-bold mb-4 leading-tight">
                    Ready to Stop Renting Your Storage?
                </h3>
                <p className="text-base sm:text-lg text-slate-400 mb-8 sm:mb-10 max-w-2xl mx-auto">
                    Let's calculate your ROI and design a Synology solution that scales with your business.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/contact-us"
                        className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(147,51,234,0.5)] shadow-[0_4px_20px_rgba(147,51,234,0.3)] text-sm sm:text-base"
                    >
                        Schedule Consultation
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CallToAction;